export default __webpack_public_path__ + "static/media/emotion-l@2x.885008cd.png";